{
  "presence": {
    "online": "En ligne",
    "away": "Absent",
    "offline": "Hors ligne"
  },
  "visibility": {
    "public": "Public",
    "friends": "Amis uniquement",
    "private": "Privé"
  },
  "reports": {
    "spam": "Spam",
    "harassment": "Harcèlement",
    "inappropriate": "Contenu inapproprié",
    "impersonation": "Usurpation",
    "other": "Autre"
  },
  "prefs": {
    "friend_request": "Demandes d’ami",
    "friend_accepted": "Acceptations d’ami",
    "message": "Messages",
    "reward": "Récompenses",
    "market": "Marché et enchères",
    "trade": "Échanges",
    "free_booster": "Boosters gratuits",
    "login_calendar": "Calendrier de connexion"
  },
  "activity": {
    "someone": "Un ami",
    "levelUp": "{{who}} a atteint le niveau {{level}}.",
    "achievement": "{{who}} a atteint « {{title}} ».",
    "achievementFallback": "un succès",
    "rareDrop": "{{who}} a obtenu {{name}} ({{rarity}}).",
    "cardFallback": "une carte",
    "rareFallback": "rare",
    "animeCompleted": "{{who}} a complété {{title}}.",
    "animeFallback": "une œuvre",
    "generic": "{{who}} a fait une action."
  },
  "notifications": {
    "someone": "Quelqu’un",
    "friendRequest": "{{who}} t’a envoyé une demande d’ami.",
    "friendAccepted": "{{who}} a accepté ta demande d’ami.",
    "messagePreview": "{{who}} : {{preview}}",
    "message": "{{who}} t’a envoyé un message.",
    "reward": "{{title}}",
    "rewardEmpty": "Nouvelle récompense",
    "achievementsMany_one": "{{count}} succès débloqué",
    "achievementsMany_other": "{{count}} succès débloqués",
    "freeBoosters": "Tes boosters gratuits sont rechargés.",
    "login": "Ta récompense du jour est prête.",
    "listingWishNamed": "{{name}} est en vente.",
    "listingWish": "Un personnage souhaité est en vente.",
    "auctionWishNamed": "{{name}} est mis aux enchères.",
    "auctionWish": "Un personnage souhaité est mis aux enchères.",
    "listingFavoriteNamed": "{{name}} est en vente.",
    "listingFavorite": "Un de tes favoris est en vente.",
    "auctionFavoriteNamed": "{{name}} est mis aux enchères.",
    "auctionFavorite": "Un de tes favoris est mis aux enchères.",
    "listingSoldNamed": "{{who}} a acheté ta carte {{name}}.",
    "listingSold": "{{who}} a acheté une de tes cartes.",
    "listingExpired": "Ton annonce pour {{name}} a expiré.",
    "auctionBidNamed": "{{who}} a misé {{amount}} Anima sur {{name}}.",
    "auctionBid": "{{who}} a misé {{amount}} Anima sur ton enchère.",
    "outbidBuyout": "{{who}} a acheté immédiatement {{name}} — tu as été remboursé.",
    "outbid": "{{who}} a surenchéri sur {{name}}.",
    "wonBuyout": "Tu as acheté immédiatement {{name}}.",
    "won": "Tu as remporté l’enchère pour {{name}}.",
    "soldBuyout": "{{who}} a acheté immédiatement {{name}}.",
    "sold": "Ton enchère pour {{name}} est terminée.",
    "unsold": "Ton enchère pour {{name}} s’est terminée sans acheteur.",
    "tradeReceived": "{{who}} t’a proposé un échange.",
    "tradeCountered": "{{who}} a contre-proposé un échange.",
    "tradeCompleted": "Échange avec {{who}} finalisé.",
    "tradeDeclined": "{{who}} a refusé ton échange.",
    "tradeCancelled": "Échange avec {{who}} annulé.",
    "tradeExpired": "Un échange a expiré.",
    "staffRequest": "{{who}} demande à modifier {{field}} sur {{name}}.",
    "staffGranted": "Tu peux modifier {{field}} sur {{name}}.",
    "staffDenied": "La modification de {{field}} sur {{name}} est refusée.",
    "fallback": "Nouvelle notification",
    "card": "une carte",
    "theCard": "la carte",
    "yourCard": "ta carte",
    "yourAuction": "ton enchère",
    "referralJoined": "{{who}} a rejoint ANIDEX avec ton code de parrainage.",
    "staffDeleteRequest": "{{who}} demande la suppression de {{name}}.",
    "staffDeleteDone": "{{name}} a été supprimé suite à ta demande.",
    "staffDeleteDenied": "La suppression de {{name}} est refusée."
  },
  "tabs": "Sections sociales",
  "friendsTab": "Amis",
  "atlasTab": "Atlas",
  "messagesTab": "Messages",
  "atlas": {
    "title": "Atlas",
    "intro": "Les collections visibles de tous tes amis, avec le propriétaire sur chaque carte.",
    "search": "Chercher un personnage, une œuvre, une étiquette ou un ami…",
    "friendFilter": "Filtrer par ami",
    "allFriends": "Tous les amis",
    "rarity": "Rareté",
    "allRarities": "Toutes",
    "noMatch": "Aucun résultat",
    "noMatchHint": "Essaie un autre filtre ou une autre recherche.",
    "noFriends": "Pas encore d’amis",
    "noFriendsHint": "Ajoute des amis pour explorer leurs collections ici.",
    "goFriends": "Voir les amis",
    "empty": "Atlas vide",
    "emptyHint": "Tes amis n’ont pas encore de cartes visibles, ou leurs collections sont privées."
  },
  "friends": {
    "title": "Social",
    "intro": "Amis, demandes et activité récente.",
    "addTitle": "Ajouter un ami",
    "username": "Pseudo du joueur",
    "add": "Ajouter",
    "requests": "Demandes",
    "incoming": "Demande reçue",
    "outgoing": "Demande envoyée",
    "accepted": "Demande acceptée",
    "acceptFailed": "Impossible d’accepter",
    "accept": "Accepter",
    "declineFailed": "Impossible de refuser",
    "decline": "Refuser",
    "cancelFailed": "Annulation impossible",
    "nowFriends": "Vous êtes maintenant amis",
    "sent": "Demande envoyée",
    "sendFailed": "Demande impossible",
    "list": "Amis ({{total}})",
    "empty": "Aucun ami pour l’instant",
    "emptyHint": "Ajoute un joueur par son pseudo pour commencer.",
    "meta": "Niveau {{level}} · amis depuis le {{date}}",
    "favorite": "Favori",
    "messageFailed": "Message impossible",
    "message": "Message",
    "removeConfirm": "Retirer {{username}} de tes amis ?",
    "removeFailed": "Retrait impossible",
    "remove": "Retirer",
    "activity": "Activité des amis",
    "activityEmpty": "Rien de récent",
    "activityHint": "Les exploits de tes amis apparaîtront ici."
  },
  "report": {
    "title": "Signaler {{name}}",
    "sent": "Signalement envoyé",
    "blocked": "{{name}} a aussi été bloqué.",
    "thanks": "Merci, l’équipe pourra l’examiner.",
    "failed": "Signalement impossible",
    "reason": "Motif",
    "details": "Détails (optionnel)",
    "placeholder": "Décris le problème…",
    "alsoBlock": "Bloquer aussi ce joueur",
    "submit": "Envoyer le signalement"
  },
  "inbox": {
    "new": "Nouvelle discussion",
    "search": "Chercher un joueur ou un message…",
    "filters": "Afficher les conversations",
    "all": "Toutes",
    "unread": "Non lues",
    "conversations": "Tes conversations",
    "shown_one": "{{count}} discussion",
    "shown_other": "{{count}} discussions",
    "unreadCount_one": "{{count}} nouveau message",
    "unreadCount_other": "{{count}} nouveaux messages",
    "you": "Toi :",
    "mutedShort": "En sourdine",
    "caughtUp": "Tout est lu",
    "noMatch": "Aucune discussion trouvée",
    "noMatchHint": "Essaie un autre nom ou affiche toutes tes conversations.",
    "reset": "Effacer les filtres",
    "manage": "Gérer la conversation avec {{name}}",
    "title": "Messages",
    "intro": "Discute avec tes amis et partage des cartes.",
    "emptyPreview": "Aucun message",
    "sharedCard": "Carte partagée : {{name}}",
    "messageFallback": "Message",
    "unmute": "Réactiver les notifications de {{name}}",
    "mute": "Mettre {{name}} en sourdine",
    "muted": "Conversation en sourdine",
    "unmuted": "Notifications réactivées",
    "muteFailed": "Sourdine impossible",
    "delete": "Supprimer la conversation avec {{name}}",
    "hideConfirm": "Masquer cette conversation ?",
    "deleteFailed": "Suppression impossible",
    "empty": "Aucune conversation",
    "seeFriends": "Voir mes amis",
    "emptyHint": "Ouvre une discussion depuis la fiche d’un ami."
  },
  "conversation": {
    "options": "Cette conversation",
    "viewProfile": "Voir le profil du joueur",
    "messageActions": "Actions du message",
    "deleteConfirm": "Supprimer ce message ? Cette action est définitive.",
    "history": "Historique de la conversation",
    "today": "Aujourd’hui",
    "yesterday": "Hier",
    "latest": "Derniers messages",
    "sending": "Envoi en cours…",
    "keyboardHint": "Entrée pour envoyer, Maj + Entrée pour une nouvelle ligne.",
    "reactionFailed": "Réaction impossible",
    "reactionCount_one": "{{reaction}}, {{count}} réaction",
    "reactionCount_other": "{{reaction}}, {{count}} réactions",
    "reactions": { "heart": "Cœur", "fire": "Feu", "star": "Étoile", "spark": "Étincelles", "laugh": "Rire", "wow": "Surprise" },
    "react": "Réagir",
    "pickEmoji": "Choisir un emoji",
    "reportMessage": "Signaler ce message",
    "deleted": "Message supprimé",
    "deleteFailed": "Suppression impossible",
    "delete": "Supprimer",
    "missing": "Conversation introuvable",
    "back": "Retour",
    "missingHint": "Cette discussion n’existe plus ou a été masquée.",
    "backToMessages": "Retour aux messages",
    "nothingToReport": "Aucun message à signaler",
    "report": "Signaler",
    "blockConfirm": "Bloquer {{username}} ?",
    "blocked": "Joueur bloqué",
    "blockFailed": "Blocage impossible",
    "block": "Bloquer",
    "which": "Quel message signaler ?",
    "touch": "Touche un message de {{username}}.",
    "start": "Commence la discussion",
    "startHint": "Envoie un message ou partage une carte depuis ta collection.",
    "label": "Message",
    "placeholder": "Écrire un message…",
    "send": "Envoyer",
    "sendFailed": "Envoi impossible"
  },
  "alerts": {
    "title": "Notifications",
    "intro": "Demandes, messages et récompenses.",
    "markFailed": "Impossible de tout marquer",
    "markAll": "Tout marquer comme lu",
    "push": "Notifications push",
    "empty": "Aucune notification",
    "emptyHint": "Tu es à jour.",
    "deleteFailed": "Suppression impossible",
    "clear": "Effacer",
    "grouped": " · ×{{total}}"
  },
  "push": {
    "checking": "Vérification des notifications push…",
    "unsupported": "Ce navigateur ne prend pas en charge les notifications push.",
    "serverOff": "Les notifications push ne sont pas encore activées sur le serveur.",
    "disabled": "Notifications push désactivées",
    "enabled": "Notifications push activées",
    "enabledHint": "Tu seras alerté même hors de l’app.",
    "denied": "Permission refusée",
    "deniedHint": "Autorise les notifications dans les réglages du navigateur.",
    "unavailable": "Push indisponible",
    "failed": "Action impossible",
    "intro": "Reçois les messages, échanges et ventes sur ton téléphone et ton ordinateur, même quand ANIDEX est fermé.",
    "wait": "Patiente…",
    "turnOff": "Désactiver les push",
    "turnOn": "Activer les notifications push",
    "blocked": "Les notifications sont bloquées par le navigateur."
  },
  "profile": {
    "sections": "Rubriques du profil",
    "languageHint": "Choisis la langue de ton interface.",
    "noneBlocked": "Aucun joueur bloqué.",
    "blockedOn": "Bloqué le {{date}}",
    "unblocked": "Joueur débloqué",
    "unblockFailed": "Déblocage impossible",
    "unblock": "Débloquer",
    "level": "Niveau {{level}}",
    "xpToNext": "{{current}} / {{next}} EXP avant le niveau {{level}}",
    "balanceLabel": "Solde",
    "viewPublic": "Voir mon profil public",
    "edit": "Modifier le profil",
    "admin": "Administration",
    "stats": "Statistiques",
    "collection": "Collection",
    "characters": "Personnages",
    "divines": "Divines obtenues",
    "mythics": "Mythiques obtenues",
    "animes": "Œuvres complétées",
    "progress": "Progression",
    "boosters": "Boosters ouverts",
    "quests": "Quêtes réussies",
    "upgrades": "Améliorations",
    "fragments": "Fragments",
    "fragmentsHeld": "En réserve",
    "fragmentsEarned": "Accumulés au total",
    "unlocks": "Récompenses débloquées",
    "unlocksEmpty": "Titres, badges et cadres gagnés grâce aux succès s’afficheront ici.",
    "blocked": "Joueurs bloqués",
    "settings": "Réglages",
    "theme": "Thème",
    "themeHint": "Auto suit le réglage de ton appareil.",
    "sound": "Sons d’interface",
    "soundHint": "Bruits doux pour la navigation et les ouvertures.",
    "privacy": "Profil, confidentialité et notifications",
    "privacyHint": "Vitrine, bannière, titre, visibilité et préférences.",
    "account": "Compte",
    "accountLine": "{{email}} ({{status}}), membre depuis le {{date}}",
    "verified": "vérifiée",
    "unverified": "non vérifiée",
    "discord": "Discord",
    "discordHint": "Le serveur officiel.",
    "rules": "Règles du jeu",
    "rulesHint": "Taux, garanties, raretés et niveaux.",
    "avatar": "Avatar",
    "avatarHint": "Touche « Utiliser comme avatar » sur une de tes cartes pour le changer.",
    "data": "Mes données",
    "dataHint": "Fichier JSON : compte, sessions, cartes, journal, messages.",
    "dataDownload": "Télécharger",
    "dataPending": "Préparation…",
    "delete": "Supprimer mon compte",
    "deleteHint": "Efface l’email, le pseudo et la collection. Irréversible.",
    "logout": "Se déconnecter"
  },
  "accountDelete": {
    "title": "Supprimer mon compte",
    "intro": "Cette action est définitive. ANIDEX ne restaure pas un compte supprimé.",
    "consequences": [
      "L’email, le pseudo et le mot de passe cessent de fonctionner.",
      "La collection, les fragments, les amis et le texte des messages sont effacés.",
      "Les annonces, enchères et échanges en cours sont annulés. Une mise en cours te est rendue, ou rendue à l’enchérisseur si c’est toi qui vends.",
      "L’Anima restante reste sur un identifiant anonyme. Personne ne peut s’en servir. Ce n’est pas de l’argent.",
      "L’adresse IP peut servir à créer un nouveau compte.",
      "Un message déjà publié sur Discord n’est pas retiré."
    ],
    "policy": "Lire le détail dans la politique de confidentialité",
    "password": "Mot de passe",
    "pending": "Suppression…",
    "submit": "Supprimer définitivement"
  },
  "editor": {
    "title": "Modifier le profil",
    "saved": "Profil mis à jour",
    "saveFailed": "Enregistrement impossible",
    "titleLabel": "Titre",
    "noTitle": "Aucun titre",
    "banner": "Bannière",
    "bannerDefault": "Par défaut",
    "bannerSearch": "Chercher une œuvre…",
    "bannerEmpty": "Aucune œuvre ne correspond.",
    "showcase": "Vitrine ({{current}}/{{slots}})",
    "showcaseEmpty": "Ajoute des favoris dans ta collection pour les placer en vitrine.",
    "privacy": "Confidentialité",
    "profileVisibility": "Visibilité du profil",
    "collectionVisibility": "Visibilité de la collection",
    "tradeVisibility": "Qui peut me proposer un échange",
    "showAnima": "Afficher mon Anima",
    "showPresence": "Afficher ma présence",
    "allowRequests": "Autoriser les demandes d’ami",
    "notifications": "Notifications",
    "style": "Style",
    "styleBadges": "Badges ({{current}}/3)",
    "styleFrame": "Cadre",
    "styleAvatar": "Filtre d’avatar",
    "styleBanner": "Filtre de bannière",
    "styleLocked": "À débloquer",
    "styleNone": "Aucun"
  },
  "public": {
    "nowFriends": "Vous êtes amis",
    "requestSent": "Demande envoyée",
    "requestFailed": "Demande impossible",
    "addFriend": "Ajouter en ami",
    "cancelRequest": "Annuler la demande",
    "accept": "Accepter",
    "decline": "Refuser",
    "messageFailed": "Message impossible",
    "message": "Message",
    "trade": "Proposer un échange",
    "blockConfirm": "Bloquer {{username}} ?",
    "blocked": "Joueur bloqué",
    "blockFailed": "Blocage impossible",
    "block": "Bloquer",
    "report": "Signaler",
    "copyLink": "Copier le lien",
    "privateCollection": "Collection privée",
    "privateHint": "Ce joueur ne partage pas sa collection.",
    "emptyCollection": "Collection vide",
    "emptyCollectionHint": "Aucune carte visible.",
    "compareUnavailable": "Comparaison indisponible",
    "compareHint": "Connecte-toi et assure-toi que la collection est visible.",
    "common": "En commun",
    "onlyYou": "Seulement toi",
    "onlyThem": "Seulement eux",
    "compareCards": "Cartes de comparaison",
    "shared": "Commun",
    "me": "Moi",
    "them": "Eux",
    "noCards": "Aucune carte",
    "noCardsHint": "Change de filtre pour explorer.",
    "level": "Niveau {{level}}",
    "memberSince": "membre depuis le {{date}}",
    "anima": "Anima",
    "views": "Vues du profil",
    "profile": "Profil",
    "collection": "Collection",
    "compare": "Comparer",
    "stats": "Statistiques",
    "characters": "Personnages",
    "divines": "Divines",
    "mythics": "Mythiques",
    "legendaries": "Légendaires",
    "animes": "Œuvres complétées",
    "showcase": "Vitrine",
    "showcaseEmpty": "Aucune carte en vitrine.",
    "favorites": "Favoris",
    "favoritesEmpty": "Aucun favori affiché.",
    "unlocks": "Déblocages",
    "unlocksEmpty": "Aucun déblocage public."
  },
  "referralTab": "Parrainage",
  "referral": {
    "title": "Parrainage",
    "intro": "Invite tes amis : chaque ami qui vérifie son compte avec ton code reçoit un boost de départ, et toi tu progresses dans le succès « Parrain ».",
    "yourCode": "Ton code de parrainage",
    "copyCode": "Copier le code",
    "copyLink": "Copier le lien",
    "share": "Partager",
    "shareText": "Rejoins-moi sur ANIDEX avec mon code {{code}} et reçois {{anima}} Anima + {{boosters}} boosters Premium !",
    "copied": "Copié !",
    "copyFailed": "Copie impossible",
    "verifyFirst": "Vérifie ton adresse email pour obtenir ton code de parrainage.",
    "welcomeTitle": "Ce que reçoit ton filleul",
    "welcomeReward": "{{anima}} Anima et {{boosters}} boosters Premium, dès que son email est vérifié.",
    "sponsorReward": "Pour toi : chaque filleul vérifié fait progresser le succès « Parrain », sans limite de paliers.",
    "stats": "Tes filleuls",
    "verified_one": "{{count}} filleul vérifié",
    "verified_other": "{{count}} filleuls vérifiés",
    "pending_one": "{{count}} en attente de vérification",
    "pending_other": "{{count}} en attente de vérification",
    "achievementLink": "Voir le succès Parrain",
    "listTitle": "Derniers filleuls",
    "empty": "Aucun filleul pour l’instant",
    "emptyHint": "Partage ton code ou ton lien pour inviter tes amis.",
    "statusVerified": "Vérifié",
    "statusPending": "En attente",
    "joined": "Inscrit le {{date}}",
    "sponsoredBy": "Ton parrain : {{username}}",
    "sponsorRewarded": "Bonus de bienvenue reçu.",
    "sponsorPending": "Ton bonus de bienvenue arrive dès que ton email est vérifié.",
    "redeemTitle": "Tu as un code de parrainage ?",
    "redeemHint": "Tu peux encore saisir le code d’un ami pendant {{days}} jours après ton inscription.",
    "redeemPlaceholder": "Code du parrain",
    "redeemSubmit": "Valider",
    "redeemed": "Parrain enregistré",
    "redeemedRewarded": "Bonus reçu : {{anima}} Anima et {{boosters}} boosters Premium !",
    "redeemedPending": "Vérifie ton email pour recevoir ton bonus.",
    "redeemFailed": "Code refusé"
  }
}
